// src/components/Footer.js
export default function Footer() {
  return (
    <footer className="border-t border-slate-800/80 bg-slate-950 text-slate-400 py-10 text-center text-sm">
      <p className="text-slate-300">
        © {new Date().getFullYear()}{" "}
        <span className="text-sky-400 font-semibold">Cpenn DFS & Betting Data</span>
      </p>

      <div className="mt-3 flex items-center justify-center gap-6 text-[13px]">
        <a
          href="/legal"
          className="transition-colors hover:text-sky-300"
        >
          Privacy & Terms
        </a>
        <span className="h-4 w-px bg-slate-700/80" />
        <a
          href="/contact"
          className="transition-colors hover:text-sky-300"
        >
          Contact
        </a>
      </div>

      <div className="mt-5 text-[11px] text-slate-500">
        Data-driven DFS tools for NASCAR, NFL, MLB, and NBA.
      </div>
    </footer>
  );
}
